import React from 'react';
import { Text } from 'rebass/styled-components';
import styled from 'styled-components';
import { humanizeCount } from 'helpers/humanizeCount';
import PropTypes from 'prop-types';

export const TooltipContain = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 1em;
  border-radius: 1em;
  box-shadow: 0 0 12px #c0c5cd;
  text-align: center;
`;

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <TooltipContain>
        <Text fontSize="14px" fontWeight="medium">
          {payload[0]?.payload?.name}
        </Text>
        <Text fontSize="14px" fontWeight="medium">
          {humanizeCount(payload[0]?.payload?.line)} employees
        </Text>
      </TooltipContain>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  active: PropTypes.bool.isRequired,
  payload: PropTypes.array.isRequired,
};

export default CustomTooltip;
